import { useContext, useMemo } from "react";
import TrunkLeafNavigationContext from "../contexts/TrunkLeafNavigationContext";

const useTrunkLeafNavigationRouter = <TProps extends object>() => {
	const ctx = useContext(TrunkLeafNavigationContext);
	if (!ctx) {
		throw new Error(`Invalid context usage for store`);
	}
	const result = useMemo(() => {
		if (!ctx) return null;
		return {
			navigateToLeaf: (props: TProps) => {
				ctx.store.getState().navigateToLeaf(props);
			},
			navigateToTrunk: () => {
				ctx.store.getState().navigateToTrunk();
			},
		};
	}, [ctx]);
	return result;
};
export default useTrunkLeafNavigationRouter;
